
import { Component, Vue, Prop } from 'vue-property-decorator'
// @ts-ignore
import CircleProgress from 'vue-circleprogressbar'

@Component({
  components: {
    CircleProgress,
  },
})
export default class FileListItem extends Vue {
  @Prop() file!: any
  @Prop({ default: 0 }) index!: number
  @Prop({ default: false }) uploading!: boolean
  @Prop({ default: true }) showDeleteOption!: boolean
  @Prop({ required: true }) fileType!: 'zip' | 'pdf' | 'word'
  @Prop({}) fileSize!: number

  get fileName() {
    return this.file[this.fileType]?.name || ''
  }

  get iconName() {
    const icons = {
      zip: '#icon-file-zip',
      pdf: '#icon-file-pdf',
      word: '#icon-file-word',
    }
    return icons[this.fileType]
  }

  sizeFilter(bytesize: number) {
    let i = 0
    // 当bytesize 大于是1024字节时，开始循环，当循环到第4次时跳出
    while (Math.abs(bytesize) >= 1024) {
      bytesize = bytesize / 1024
      i++
      if (i === 4) break
    }
    // 将Bytes,KB,MB,GB,TB定义成一维数组
    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    const newsize = bytesize.toFixed(2)
    return newsize + ' ' + units[i]
  }
}
